import {
  LoanVendorDocumentRequestStatus,
  LoanVendorDocumentStatus,
  LoanVendorStatus,
  MediaPurpose,
  Vendor,
  VendorMediaPurpose,
} from "../../../../hooks/api/types";
import { VendorCategories, VendorDocumentRequestStatus } from "./types";

export const categorizeVendors = (vendors: Array<Vendor>): VendorCategories => {
  return vendors.reduce(
    (acc, vendor: Vendor) => {
      if (!vendor?.status) return acc;

      switch (vendor.status) {
        case LoanVendorStatus.ACTIVE:
          acc.approved.push(vendor);
          break;
        case LoanVendorStatus.DRAFT:
          acc.draft.push(vendor);
          break;
        case LoanVendorStatus.PENDING_DOCUMENTS:
          acc.pending.push(vendor);
          break;
        case LoanVendorStatus.REJECTED_BY_OPS:
          acc.rejected.push(vendor);
          break;
        case LoanVendorStatus.REJECTED_BY_UW:
          acc.rejected.push(vendor);
          break;
        case LoanVendorStatus.PENDING_REVIEW:
          acc.pendingReview.push(vendor);
          break;
      }
      return acc;
    },
    {
      approved: [] as Array<Vendor>,
      draft: [] as Array<Vendor>,
      pending: [] as Array<Vendor>,
      rejected: [] as Array<Vendor>,
      pendingReview: [] as Array<Vendor>,
    }
  );
};

export const getVendorDocumentRequestStatus = (
  vendors: Array<Vendor>
): VendorDocumentRequestStatus => {
  return vendors?.reduce(
    (acc, vendor: Vendor) => {
      if (!vendor?.loanVendorDocumentRequests) return acc;

      const hasOnlyBankStatementRequests =
        vendor.loanVendorDocumentRequests.every(
          (request) => request.type === VendorMediaPurpose.BANK_STATEMENT
        );

      const hasBankStatementRequest = vendor.loanVendorDocumentRequests?.some(
        (request) => request.type === VendorMediaPurpose.BANK_STATEMENT
      );

      const hasDraftDocuments = vendor.loanVendorDocumentRequests
        ?.filter(
          (req) => req.status === LoanVendorDocumentRequestStatus.PENDING
        )
        ?.every((request) => request.loanVendorDocuments?.length > 0);

      const documentsPending = vendor.loanVendorDocumentRequests
        ?.filter((req) => req.type !== MediaPurpose.BANK_STATEMENT)
        ?.some(
          (request) =>
            request.status === LoanVendorDocumentRequestStatus.PENDING
        );

      if (!hasOnlyBankStatementRequests && documentsPending) {
        acc.vendorsPendingDocs.push(vendor);
      }

      if (
        vendor.status === LoanVendorStatus.PENDING_DOCUMENTS &&
        hasBankStatementRequest
      ) {
        acc.pendingBankStatementVendors.push(vendor);
      }

      if (!hasDraftDocuments) {
        acc.informationUploaded = false;
      }

      return acc;
    },
    {
      vendorsPendingDocs: [] as Vendor[],
      pendingBankStatementVendors: [] as Vendor[],
      informationUploaded: true as boolean,
    }
  );
};
